export const getElementSizes = (element: HTMLElement): number[] => {
  const computedStyle = getComputedStyle(element);

  const sizesDefinition = computedStyle.getPropertyValue(
    '--responsive-container'
  );

  return sizesDefinition
    ?.replace(/\$/g, '')
    ?.split(',')
    ?.map((size) => parseInt(size.trim(), 10));
};

export const responsive = (element: HTMLElement, prop = 'component-width') => {
  const sizes = getElementSizes(element);

  // eslint-disable-next-line compat/compat
  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ contentRect: { width } }) => {
      element.setAttribute(
        prop,
        (sizes.find((size) => size < width) || 0).toString()
      );
      (element as any).onAfterResize?.();
    });
  });
  observer.observe(element);
};
